import Request from "../../../lib/request";
import { PROJECT_USER_ID } from "../../../constants/storageKeys";
import {
  CONTACT_REVIEW_REPORT_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../../constants/api";
import { PAGE } from "../../../constants/filters";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const getList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${CONTACT_REVIEW_REPORT_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
